import { Application } from '@hotwired/stimulus';

import { EmbedV1CarouselController } from 'dashery/controllers/embed/v1/carousel_controller';

// Stimulus Application Setup
const application = Application.start(document.documentElement);

application.register('embed--v1--carousel', EmbedV1CarouselController);